import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

const uri = "api/user/user-fortune";

export type UserFortuneResult = {
  isDrawnToday: boolean;
  fortuneDate: string;
  resultImage: string | null;
  acquiredPoint: number;
};

export type PostUserFortuneParam = {
  pointOwnerId: number;
  resultImage: string;
};

export type FetchUserFortuneParam = {
  pointOwnerId: number;
};

export const fetchUserFortuneAtom = atom<State<UserFortuneResult> | null>(null);

export const postUserFortuneAtom = atom<State<UserFortuneResult> | null>(null);

export const fetchUserFortune = () => {
  return fetchBase<UserFortuneResult, FetchUserFortuneParam>(
    uri,
    fetchUserFortuneAtom
  );
};

export const postUserFortune = () => {
  return postBase<UserFortuneResult, PostUserFortuneParam>(
    uri,
    postUserFortuneAtom
  );
};
